import { Component, Inject, OnInit } from '@angular/core';
import { IStepValidation, WizardStep } from '../../WizardStep';
import {
  ContactContactSelectionStepComponent,
} from '../contact-contact-selection-step/contact-contact-selection-step.component';
import {
  ContactCreateMessageStepComponent,
} from '../contact-create-message-step/contact-create-message-step.component';
import { openSnackbar } from '../../../../store/actions/page.action';
import { MessageService } from '../../../../store/services/message.service';
import { WIZARD_COMPONENT, WizardComponent } from '../../wizard.component';
import { Store } from '@ngrx/store';
import { IReducers } from '../../../../store/reducers';

@Component({
  selector: 'app-wait-for-one-time-message',
  templateUrl: './wait-for-one-time-message.component.html',
  styleUrls: ['./wait-for-one-time-message.component.scss'],
})
export class WaitForOneTimeMessageComponent implements OnInit, WizardStep {

  static STEP_NAME = 'wait-for-one-time-message';

  wizardData: { [p: string]: any };

  numberOfContacts: number;

  constructor(
    private readonly messagesService: MessageService,
    @Inject(WIZARD_COMPONENT) private readonly wizardComponent: WizardComponent,
    private readonly store$: Store<IReducers>,
  ) {
  }

  provideData() {
    return null;
  }

  async validate(): Promise<IStepValidation> {
    return {
      success: true,
    };
  }

  ngOnInit(): void {
    this.numberOfContacts = this.wizardData[ContactContactSelectionStepComponent.STEP_NAME].length;

    if (this.numberOfContacts === undefined) {
      this.numberOfContacts = 0;
    }

    this.messagesService
      .sendOnetimeMessage(
        this.wizardData[ContactContactSelectionStepComponent.STEP_NAME]
          .map(c => c.contact_id)
          .join(','),
        this.wizardData[ContactCreateMessageStepComponent.STEP_NAME].message,
        this.wizardData[ContactCreateMessageStepComponent.STEP_NAME].subject,
        this.wizardData[ContactCreateMessageStepComponent.STEP_NAME].greeting,
      )
      .subscribe(
        result => {
          if (result.success) {
            this.wizardComponent.notifyFinish();
          }
        },
        error =>
          this.store$.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message:
                    'Something happen while processing the operation. Please, try again later.',
                  type: 'error',
                  button: {
                    text: 'dismiss',
                  },
                },
                verticalPosition: 'bottom',
              },
            }),
          ),
      );
  }

}
